'use client';

import './style.sass';
import '../reusable-components/style.sass';

import React from 'react';

import { listPath, listTitle } from './constants';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';
import Review from '../reusable-components/layouts-components__common-cases/review';
import Complex from '../reusable-components/layouts-components__skolkovo/complex';
import Customer from '../reusable-components/layouts-components__skolkovo/customer';
import Process from '../reusable-components/layouts-components__skolkovo/process';
import Results from '../reusable-components/layouts-components__skolkovo/results';
import SliderSkolkovo from '../reusable-components/layouts-components__skolkovo/sliderskolkovo';
import Task from '../reusable-components/layouts-components__skolkovo/task';
import Team from '../reusable-components/layouts-components__skolkovo/team';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';
import TitleCase from '../../case-components/title-case';

const reviewSkolkovo = {
    reviewText:
        'Результат работы однозначно можно назвать успешным, благодаря этому опыту есть понимание движения в&nbsp;улучшении продуктов Технопарка &laquo;Сколково&raquo;. Сформированы проблемные места и&nbsp;масштабируемые направления.',
    reviewAuthors: [
        {
            title: 'Мария Кравченко',
            subtitle: 'Руководитель департамента внешних коммуникаций',
            img: '/images/svg/skolkovo/review__author-img.jpg',
        },
    ],
    downLoadPresentationText: '&nbsp; Получить презентацию кейса',
};

const Skolkovo = () => {
    const casePathname = '/cases/marketing/skolkovo';
    const adjacentCase = getAdjacentCase(casePathname);

    return (
        <section className="skolkovo">
            <TitleCase
                img="/images/pic/skolkovo12/skolkovo12banner.jpg"
                listPath={listPath}
                listTitle={listTitle}
                caseName="skolkovo12"
            />

            <Customer />

            <Task />

            <Complex />

            <Process />

            <SliderSkolkovo />

            <Results />

            <Team />

            <Review Review={reviewSkolkovo} />
            <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                <FullWrapper>
                    <OfferButton linkText="Нанять команду" />
                </FullWrapper>
            </ScrollAnimation>

            {adjacentCase && (
                <NextProject
                    NextProject={{
                        nextProjectTitle: adjacentCase.case.title,
                        nextProjectImg: adjacentCase.case.image,
                        nextProjectLink: adjacentCase.case.router,
                        nextProjectText: adjacentCase.case.description,
                        nextProjectLabel: adjacentCase.label,
                    }}
                />
            )}
        </section>
    );
};

export default Skolkovo;
